import { render, staticRenderFns } from "./NoticeCC.vue?vue&type=template&id=ad96d8c0&scoped=true"
import script from "./NoticeCC.vue?vue&type=script&lang=js"
export * from "./NoticeCC.vue?vue&type=script&lang=js"
import style0 from "./NoticeCC.vue?vue&type=style&index=0&id=ad96d8c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad96d8c0",
  null
  
)

export default component.exports